import type { IDateUtil } from './dateUtil';

type DateInstance = ReturnType<IDateUtil>;

export default function to9AM(dateInstance: DateInstance): DateInstance {
  return dateInstance.set({ hour: 9, minute: 0, seconds: 0 });
}
